import resolveGstRates from "./gstRates";

/** Billed line total: prefer `amount` (billedInvs), else legacy `specialRate`. */
const getLineAmount = (item) =>
  Number(item?.amount) || 0;

/**
 * @param rootCharges Optional invoice-root printing/mounting (INV); not used for CRN.
 * @param taxRates Saved invoice { IGST, SGST, CGST } percentages.
 */
const getTotalValueDetails = (
  gstNumber,
  inventories,
  type,
  rootCharges,
  taxRates
) => {
  // console.log("these are the invenotires coming from me", gstNumber,inventories,type);
  let totalAmount;
  if (type === "CRN" && inventories && typeof inventories === "object" && inventories.totalAmount !== undefined) {
    // inventories is infoForCN object
    totalAmount = (Number(inventories.totalAmount) || 0) + (Number(inventories.printingCharge) || 0) + (Number(inventories.mountingCharge) || 0);
  } else if (type === "CRN") {
    // fallback: inventories is array
    totalAmount = inventories.reduce((accumulator, item) => {
      return accumulator + (Number(item.creditNoteAmount) || 0);
    }, 0);
  } else {
    const lineSum = (inventories || []).reduce(
      (accumulator, item) => accumulator + getLineAmount(item),
      0
    );
    const rootP = Number(rootCharges?.printingCharge) || 0;
    const rootM = Number(rootCharges?.mountingCharge) || 0;
    totalAmount = lineSum + rootP + rootM;
  }

  const { igstRate, cgstRate, sgstRate } = resolveGstRates(gstNumber, taxRates);

  const igstValue = (totalAmount * igstRate) / 100;
  const cgstValue = (totalAmount * cgstRate) / 100;
  const sgstValue = (totalAmount * sgstRate) / 100;

  const totalInvoiceValue = totalAmount + igstValue + cgstValue + sgstValue;

  const result = {
    AssVal: totalAmount,
    IgstVal: igstValue,
    CgstVal: cgstValue,
    SgstVal: sgstValue,
    CesVal: 0,
    StCesVal: 0,
    Discount: 0,
    OthChrg: 0,
    RndOffAmt: 0,
    TotInvVal: totalInvoiceValue,
  };
  return result;
};

export default getTotalValueDetails;
